"use strict";

const $ = require("jquery");
const {
    correctLocation,
    decodeHtml,
    parseYoutube,
    replaceHistoryState,
    setCurrentDate,
    ajaxCalls: {
        licgen,
        redirect
    }
} = require("./utils.js");

const {
    baseOnload
} = require("./modules/base.js");

const {
    TemplateLP
} = require("./modules/templateLP.js");

$(function (win, doc, history) {

    $(win).on("load", () => {

        correctLocation(win, history);
        replaceHistoryState(win, history);

    });


    $(doc).ready(function () {
        // checkIfAnalyticsLoaded();

        const tpl = new TemplateLP();

        win.tpl = tpl;

        if (window.location.href.indexOf("go.veeam.com") !== -1) {
            win.tpl.onInit();
        }

        win.tpl.onInit();

        win.tpl.devMode.init();

        setTimeout(win.tpl.localizer.forms.localizeForms.bind(win.tpl), 1200);

        if (typeof ready === "function") {
            ready();
        }

        setTimeout(function () {
            if (!($("html").hasClass("no-rgba"))) {
                var evt = doc.createEvent("CustomEvent");
                evt.initCustomEvent("MyEventType", true, true, tpl);
                win.dispatchEvent(evt);
            }
        }, 4000);

        setCurrentDate();
        baseOnload();

    });

}(window, document, window.history));



// WEBPACK FOOTER //
// ./src/index.js